import { render, staticRenderFns } from "./uploadpz.vue?vue&type=template&id=70632431&scoped=true&"
import script from "./uploadpz.vue?vue&type=script&lang=js&"
export * from "./uploadpz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70632431",
  null
  
)

export default component.exports